import { Text } from "./text";
import { styled } from "utils";

const Badge = styled(Text, {
  fontSize: "$5",
  fontWeight: "$bold",
  padding: "$1 $3",
  borderRadius: "$2",
});

const SoldBadge = styled(Badge, {
  position: "absolute",
  top: "$3",
  right: 0,
  backgroundColor: "$yellow",
});

export { Badge, SoldBadge };
